import React, { Component, Fragment } from "react"

import Form from "react-bootstrap/Form"
import { FormattedMessage } from "react-intl"

class IdentityEmail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: this.props.identity.email,
    }
  }

  render() {
    return (
      <>
        <Form>
          <Form.Group>
            <Form.Label>
              <FormattedMessage id={"Email"} />
            </Form.Label>
            <Form.Control
              name="email"
              type="email"
              value={this.state.email}
              disabled
            />
          </Form.Group>
        </Form>
      </>
    )
  }
}

export default IdentityEmail
